<div class="ai-data-insights-page">
  @if (isLoading()) {
    <div class="policy-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
  }

  @if (isLoading() === false) {
    <div class="scollable-tables">
      @if (isAccountAuthorizedToViewDataInsights) {
        <app-enterprise-ai-data-insights></app-enterprise-ai-data-insights>
      } @else {
        <div class="unauthorized-access">
          <p class="unauthorized-message">You don't have access to view this page.</p>
        </div>
      }
    </div>
  }
</div>
